<!-- AppHead.vue -->

<template>
  <Head>
    <slot />
    <title>{{ title ? `${title}` : 'Welcome | Inspire Properties' }}</title>
    <meta name="description" :content="desc ? desc : 'Discovers a wide range of properties in Dubai and UAE with Inspire Properties'">
    <meta property="og:url" :content="($page.url) ? ($page.url == '/' ? asset($page.props.app_url) : asset($page.url)) : $page.props.app_url">
    <meta name="keywords" content="inspire, properties, inspireproperties, dubairealestate, realestatedubai, news, update, market, investing, records, luxury, lifestyle, project, offplan, interior, design, estate, real, dubai, UAE, property, village, ranches, broker, sale, rent, citydubai, city, bed, jumeirah, marina, room, investor, agent, apartment, villas, community, home, flat, townhouse, penthouse, commercial, Land, residential, building">

    <meta property="og:title" :content="title ? `${title}` : 'Welcome | Inspire Properties'">
    <meta property="og:image" :content="image ? image : '/images/inspire-properties-favicon.png'">
    <meta property="og:site_name" content="Inspire Properties">
    <meta property="og:description" :content="desc ? desc : 'Discovers a wide range of properties in Dubai and UAE with Inspire Properties'">
    <meta property="og:type" content="article">
    <meta name="twitter:card" content="summary">
    <meta name="twitter:title" :content="title ? `${title}` : 'Welcome | Inspire Properties'">
    <meta name="twitter:site" content="@inspireProperties">
    <meta name="twitter:description" :content="desc ? desc : 'Discovers a wide range of properties in Dubai and UAE with Inspire Properties'">

    <link rel="apple-touch-icon" sizes="57x57" href="/images/favicons/apple-icon-57x57.png">
    <link rel="apple-touch-icon" sizes="60x60" href="/images/favicons/apple-icon-60x60.png">
    <link rel="apple-touch-icon" sizes="72x72" href="/images/favicons/apple-icon-72x72.png">
    <link rel="apple-touch-icon" sizes="76x76" href="/images/favicons/apple-icon-76x76.png">
    <link rel="apple-touch-icon" sizes="114x114" href="/images/favicons/apple-icon-114x114.png">
    <link rel="apple-touch-icon" sizes="120x120" href="/images/favicons/apple-icon-120x120.png">
    <link rel="apple-touch-icon" sizes="144x144" href="/images/favicons/apple-icon-144x144.png">
    <link rel="apple-touch-icon" sizes="152x152" href="/images/favicons/apple-icon-152x152.png">
    <link rel="apple-touch-icon" sizes="180x180" href="/images/favicons/apple-icon-180x180.png">
    <link rel="icon" type="image/png" sizes="192x192"  href="/images/favicons/android-icon-192x192.png">
    <link rel="icon" type="image/png" sizes="32x32" href="/images/favicons/favicon-32x32.png">
    <link rel="icon" type="image/png" sizes="96x96" href="/images/favicons/favicon-96x96.png">
    <link rel="icon" type="image/png" sizes="16x16" href="/images/favicons/favicon-16x16.png">
    <link rel="manifest" href="/images/favicons/manifest.json">
    <meta name="msapplication-TileColor" content="#df993b">
    <meta name="msapplication-TileImage" content="/images/favicons/ms-icon-144x144.png">
    <meta name="theme-color" content="#df993b">
  </Head>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Head,
  },
  props: {
    title: String,
    desc: String,
    image: String
  },
}
</script>
